import { RouteConfig } from 'vue-router';

export const settingsRoute: RouteConfig = {
  path: '/',
  component: () =>
    import(/* webpackChunkName: "Settings" */ '@/views/main/settings/List.vue'),
  name: 'settings'
};
